import { gql } from 'apollo-angular';

export const GET_TABLE_VERSIONS = gql`
  query TableVersions {
    tableVersions {
      tableName
      version
    }
  }
`;

export const GET_TABLE_VERSION = gql`
  query GetTableVersion($tableName: String!) {
    version(model: $tableName)
  }
`;